import React from 'react';
import PropTypes from 'prop-types';

const AppointmentDetailsItem = ({ label, children, customLabelStyle = '' }) => (
  <div className='rep-apts-show__info'>
    <div className={ `rep-apts-show__info__label ${customLabelStyle}` }>{label}</div>
    {children}
  </div>
);

AppointmentDetailsItem.propTypes = {
  customLabelStyle: PropTypes.string,
  label: PropTypes.string.isRequired
};

export default AppointmentDetailsItem;



// WEBPACK FOOTER //
// ./app/components/reps/appointments/AppointmentDetailsItem.jsx